import React from 'react';
import Error404 from './../../templates/Error404.jsx'
import ErrorCode from './../../images/errors 404/error-code.svg'

const ErrorGeneral = () => (
    < Error404 
        ImageError={ErrorCode} 
        Title="¿¿Qué?? Pero es que aqui no hay nada de codigo, Donde te metiste...️ 🤦‍♂️🤦‍♂️" 
        Description="Anda, volvamos al inicio"
        LinkRedireccion="/"
        TextRedireccion="Es por aqui"
        />
)

export default ErrorGeneral;